<template>
  <div class="waybill-table-wrapper">
    <base-loader v-if="waybillStore.dataIsLoading" />

    <TableComponent
      v-else-if="tableColumns.length > 0 && waybillStore.waybills.length > 0"
      :data="waybillStore.waybills"
      :columns="tableColumns"
      selectable
      :ready="!waybillStore.dataIsLoading"
      @selection-change="handleSelectionChange"
      @row-middle-click="
        openRouteInNewTab({
          name: 'WaybillDetails',
          params: { id: $event.id },
        })
      "
      @row-click="handleRowClick"
    />

    <div v-else class="no-data">Путевые листы не найдены</div>

    <PaginationComponent
      v-if="waybillStore.pagination.pages > 1 && !waybillStore.dataIsLoading"
      :page="waybillStore.pagination.page"
      :pages="waybillStore.pagination.pages"
      :series="waybillStore.pagination.series"
      @update:page="handlePageChange"
    />
  </div>
</template>

<script>
import TableComponent from "@/components/TableComponent.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";

import { useWaybillStore } from "@/stores/waybillStore";
import { useTableConfigStore } from "@/stores/tableConfigStore";

import { openRouteInNewTab } from "@/utils/routeUtils";

export default {
  name: "WaybillTable",

  components: {
    TableComponent,
    PaginationComponent,
  },

  emits: ["selection-change"],

  data() {
    return {
      tableColumns: [],
    };
  },

  computed: {
    waybillStore() {
      return useWaybillStore();
    },

    tableConfigStore() {
      return useTableConfigStore();
    },
  },

  methods: {
    async loadTableConfig() {
      try {
        const columns = await this.tableConfigStore.initTableConfiguration(
          "Waybill",
          "waybills"
        );
        this.tableColumns = columns.filter((col) => col.enabled !== false);
      } catch (error) {
        console.error("Не удалось загрузить конфигурацию таблицы путевых листов:", error);
        try {
          const { loadTableColumns } = await import("@/components/Table/formatter");
          this.tableColumns = await loadTableColumns("waybills");
        } catch (fallbackError) {
          console.error("Ошибка загрузки таблицы:", fallbackError);
          this.tableColumns = [];
        }
      }
    },

    handleRowClick(item) {
      this.$router.push({
        name: "WaybillDetails",
        params: { id: item.id },
      });
    },

    handleSelectionChange(selected) {
      this.$emit("selection-change", selected);
    },

    handlePageChange(page) {
      this.waybillStore.fetchWaybills({ page });
    },

    openRouteInNewTab,
  },

  async mounted() {
    await this.loadTableConfig();
  },
};
</script>
